import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const AddSalonModal = ({ isOpen, onClose, onSave, ownerId }) => {
  const [formData, setFormData] = useState({
    owner: '66e78c12fa3a5f4bcd92ab11',
    name: '',
    address: '',
    phone: '',
    description: '',
    workingHours: {
      start: '09:00',
      end: '21:00',
    },
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors?.[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: '',
      }));
    }
  };

  const handleWorkingHoursChange = (type, value) => {
    setFormData((prev) => ({
      ...prev,
      workingHours: {
        ...prev?.workingHours,
        [type]: value,
      },
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = 'نام سالن الزامی است';
    }

    if (!formData?.address?.trim()) {
      newErrors.address = 'آدرس سالن الزامی است';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'شماره تلفن الزامی است';
    } else if (!/^09\d{9}$/?.test(formData?.phone)) {
      newErrors.phone = 'شماره تلفن معتبر نیست';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = { ...formData, owner: ownerId }; // attach owner dynamically
      await onSave(payload);
      handleClose();
    } catch (error) {
      console.error('Error saving salon:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      address: '',
      phone: '',
      description: '',
      workingHours: {
        start: '09:00',
        end: '21:00',
      },
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto animate-scale-in">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-lg font-semibold text-foreground">
            افزودن سالن جدید
          </h2>
          <Button
            disabled
            variant="ghost"
            size="icon"
            onClick={handleClose}
            iconName="X"
            iconSize={20}
          />
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <Input
            label="نام سالن"
            type="text"
            placeholder="نام سالن را وارد کنید"
            value={formData?.name}
            onChange={(e) => handleInputChange('name', e?.target?.value)}
            error={errors?.name}
            required
          />

          <Input
            label="آدرس"
            type="text"
            placeholder="آدرس کامل سالن را وارد کنید"
            value={formData?.address}
            onChange={(e) => handleInputChange('address', e?.target?.value)}
            error={errors?.address}
            required
          />

          <Input
            label="شماره تلفن"
            type="tel"
            placeholder="09123456789"
            value={formData?.phone}
            onChange={(e) => handleInputChange('phone', e?.target?.value)}
            error={errors?.phone}
            required
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              ساعات کاری
            </label>
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="شروع"
                type="time"
                value={formData?.workingHours?.start}
                onChange={(e) =>
                  handleWorkingHoursChange('start', e?.target?.value)
                }
              />
              <Input
                label="پایان"
                type="time"
                value={formData?.workingHours?.end}
                onChange={(e) =>
                  handleWorkingHoursChange('end', e?.target?.value)
                }
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              توضیحات (اختیاری)
            </label>
            <textarea
              className="w-full p-3 border border-border rounded-md bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              rows={3}
              placeholder="توضیحات اضافی در مورد سالن..."
              value={formData?.description}
              onChange={(e) =>
                handleInputChange('description', e?.target?.value)
              }
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={handleClose}
            className="flex-1"
            disabled={loading}>
            انصراف
          </Button>
          <Button
            variant="default"
            onClick={handleSave}
            loading={loading}
            className="flex-1"
            iconName="Plus"
            iconPosition="right">
            افزودن سالن
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddSalonModal;
